import appStore from 'store';
import api from './api';
const store = {
  namespaced: true,
  state: {
    projects: [],
    totalCount: 0,
    coinTypeList: [],
    pairList: [],
    editingProject: null,
    pagination: {
      page: 1,
      size: 25
    }
  },
  getters: {},
  mutations: {
    setList(state, payload) {
      state.projects = payload.list;
      state.totalCount = payload.totalCount;
    },
    setCoinTypeList(state, payload) {
      state.coinTypeList = payload;
    },
    setEditingProject(state, payload) {
      state.editingProject = payload;
    },
    setPairList(state, payload) {
      state.pairList = payload;
    }
  },
  actions: {
    getList({ commit }, query) {
      api.getList(query).then(({ data }) => {
        commit('setList', data);
      });
    },
    update(context, data) {
      return api.update(data);
    },
    getCoinTypeList({ commit }) {
      api.getCoinTypeList().then(({ data }) => {
        commit('setCoinTypeList', data);
      });
    },
    listAllCoin({ commit }) {
      api.getAllpair().then(({ data }) => {
        commit('setPairList', data);
      });
    },
    create(context, data) {
      return api.create(data);
    },
    createTest(context, data) {
      return api.createTest(data);
    },
    removeOrder(context, data) {
      return api.removeOrder(data);
    }
  }
};

appStore.registerModule('lever', store);
